import { TagsManagerGridWebComponent } from './component/TagsManagerGridWebComponent';
import { WEB_COMPONENT_TAGS_MANAGER_GRID } from '../../webcomponents.constants';

export { TagsManagerGridWebComponent };

window.customElements.define(WEB_COMPONENT_TAGS_MANAGER_GRID, TagsManagerGridWebComponent);
